module.exports = __webpack_public_path__ + "img/TC.a826072d.svg";